import moment from 'moment';

export const isTodayFutureTime = (time) => {
  return time >= moment().startOf('day') && moment().isSame(time, 'day');
};

export const isTodayOrBefore = (time) => {
  return time <= Date.now() || moment().isSame(time, 'day');
};

export const isTodayOrFuture = (time) => {
  return time >= Date.now() || moment().isSame(time, 'day');
}

export const isToday = (time) => {
  return moment().isSame(time, 'day');
};